document.addEventListener("DOMContentLoaded", () => {

  const hero = document.querySelector("[data-hero]");
  if (!hero) return;

  const slides = hero.querySelectorAll(".hero__slide");
  const stories = hero.querySelectorAll(".hero__story");

  const autoplay = hero.dataset.autoplay === "true";
  const globalDuration = parseInt(hero.dataset.globalDuration, 10) || 5000;

  let current = 0;
  let rafId = null; // ← para cancelar animaciones

  function showSlide(index) {

    // Cancelar animación anterior
    if (rafId) cancelAnimationFrame(rafId);

    slides.forEach(slide => slide.classList.remove("is-active"));
    slides[index].classList.add("is-active");

    stories.forEach(story => {
      const progress = story.querySelector(".hero__progress");
      if (progress) progress.style.width = "0%";
    });

    current = index;

    if (stories.length <= 1) return;

    const slide = slides[current];
    const custom = parseInt(slide.dataset.duration, 10) || 0;
    const duration = custom > 0 ? custom : globalDuration;

    if (autoplay) startProgress(duration);
  }

  function startProgress(duration) {

    const progress = stories[current].querySelector(".hero__progress");
    if (!progress) return;

    let start = null;

    function animate(timestamp) {

      if (!start) start = timestamp;

      const elapsed = timestamp - start;
      const percent = Math.min((elapsed / duration) * 100, 100);

      progress.style.width = percent + "%";

      if (elapsed < duration) {
        rafId = requestAnimationFrame(animate);
      } else {
        nextSlide();
      }
    }

    rafId = requestAnimationFrame(animate);
  }

  function nextSlide() {
    const next = (current + 1) % slides.length;
    showSlide(next);
  }

  stories.forEach((btn, i) => {
    btn.addEventListener("click", () => showSlide(i));
  });

  showSlide(0);

});